var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenshare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0135 58H63.2165C62.3403 58 61.6328 58.7392 61.6328 59.6549V65.1319V69.5001V76.6235V79.9753C61.6328 80.3617 61.7775 80.7061 61.9945 80.9917C62.284 81.3697 62.7101 81.6301 63.2085 81.6301H70.3072H75.0826H82.1331H86.5467H92.0135C92.8898 81.6301 93.5972 80.8909 93.5972 79.9753V59.6549C93.5972 58.7392 92.8898 58 92.0135 58Z",
    stroke: "black",
    strokeWidth: 0.808815,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4765 68.2988H53.1433C52.2671 68.2988 51.5596 69.0381 51.5596 69.9537V75.4307V79.7989V90.2825C51.5596 91.1982 52.2671 91.9374 53.1433 91.9374H72.0599H76.4735H81.9402C82.8165 91.9374 83.524 91.1982 83.524 90.2825V86.0908",
    stroke: "black",
    strokeWidth: 0.808815,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4111 78.5979H43.0779C42.2016 78.5979 41.4941 79.3371 41.4941 80.2527V85.7297V90.0978V100.581C41.4941 101.497 42.2016 102.236 43.0779 102.236H61.9945H66.4081H71.8749C72.7511 102.236 73.4586 101.497 73.4586 100.581V96.3895",
    stroke: "black",
    strokeWidth: 0.808815,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshare);
export default __webpack_public_path__ + "static/media/screenshare.b4cbd01cbd33917ace6edb155711d57c.svg";
export { ForwardRef as ReactComponent };